// extracted by mini-css-extract-plugin
export default {"tableContainer":"TableSales_tableContainer__Kdmt0"};